import { Button, IconMinus, IconPlus, Spinner, SuccessIcon } from "@heroui/react"
import { tamu } from "@ramoo/i18n/tamu"
import type { ReactNode } from "react"

/*
 * Bagian kecil yang dipakai lebih dari satu layar tamu. Semuanya komposisi komponen HeroUI dan
 * kelas Tailwind bertoken; tidak ada gaya sendiri.
 */

/** Layar satu pesan di tengah: memuat, galat, pesanan terkirim, lunas. */
export function Pusat({ children }: { children: ReactNode }) {
  return (
    <div className="mx-auto flex min-h-dvh max-w-xl flex-col items-center justify-center gap-3 p-6 text-center">
      {children}
    </div>
  )
}

/** Judul layar satu pesan. */
export function JudulPusat({ children }: { children: ReactNode }) {
  return <h1 className="text-2xl leading-8 font-semibold">{children}</h1>
}

/** Tanda berhasil di atas judul. Warnanya warna status, bukan aksen etalase. */
export function Berhasil() {
  return (
    <div className="flex size-16 items-center justify-center rounded-full bg-success-soft text-success-soft-foreground">
      <SuccessIcon className="size-8" />
    </div>
  )
}

/** Penanda memuat dengan keterangannya. */
export function Memuat({ children }: { children: ReactNode }) {
  return (
    <>
      <Spinner size="lg" />
      <p className="text-sm text-muted">{children}</p>
    </>
  )
}

/**
 * Jumlah: dua tombol dan angka di antaranya. Padanan `number-stepper` Pro dengan paket gratis.
 * `NumberField` gratis tidak dipakai: angkanya jadi isian, dan mengetuknya membuka papan ketik
 * di atas lembar yang sedang terbuka.
 */
export function Jumlah({
  nilai,
  bisaKurang = true,
  bisaTambah = true,
  besar = false,
  onKurang,
  onTambah,
}: {
  nilai: number
  bisaKurang?: boolean
  bisaTambah?: boolean
  /** Ukuran lembar detail; bawaan ukuran baris keranjang. */
  besar?: boolean
  onKurang: () => void
  onTambah: () => void
}) {
  const ukuran = besar ? "md" : "sm"
  return (
    <span className="inline-flex shrink-0 items-center gap-2">
      <Button
        isIconOnly
        size={ukuran}
        variant="tertiary"
        aria-label={tamu().kurangi}
        isDisabled={!bisaKurang}
        onPress={onKurang}
      >
        <IconMinus />
      </Button>
      <b className="min-w-6 text-center font-semibold tabular-nums" aria-live="polite">
        {nilai}
      </b>
      <Button
        isIconOnly
        size={ukuran}
        variant="tertiary"
        aria-label={tamu().tambahSatu}
        isDisabled={!bisaTambah}
        onPress={onTambah}
      >
        <IconPlus />
      </Button>
    </span>
  )
}
